// Project Imports
import ModuleIdentifierConst from 'core/common/moduleIdentifier';
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const img = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4824 2.00781C18.388 2.00781 19.125 2.74359 19.125 3.64844V13.2012C19.125 14.106 18.388 14.8418 17.4824 14.8418H8.38086L5.10254 18.1162C5.00972 18.2088 4.88554 18.2578 4.75977 18.2578C4.6973 18.2578 4.63413 18.2454 4.57422 18.2207C4.39297 18.1457 4.27546 17.9692 4.27539 17.7734V14.8418H2.51758C1.61205 14.8417 0.875 14.106 0.875 13.2012V3.64844C0.875008 2.74359 1.61206 2.00788 2.51758 2.00781H17.4824ZM2.51758 2.97656C2.14667 2.97663 1.84473 3.27843 1.84473 3.64844V13.2012C1.84473 13.5712 2.14667 13.873 2.51758 13.873H4.75977C5.02764 13.873 5.24506 14.0898 5.24512 14.3574V16.6025L7.83691 14.0146C7.92776 13.9239 8.05102 13.8731 8.17969 13.873H17.4824C17.8533 13.873 18.1553 13.5713 18.1553 13.2012V3.64844C18.1553 3.27832 17.8533 2.97656 17.4824 2.97656H2.51758Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.25"
    />
    <path
      d="M12.6222 7.06242H11.2895L12.0289 5.55164C12.075 5.45735 12.0606 5.35067 11.9901 5.26686C11.9197 5.18302 11.8027 5.13281 11.6776 5.13281H9.1012C8.95253 5.13281 8.81785 5.20335 8.75658 5.31318L7.03321 8.41152C6.98083 8.50626 6.99077 8.61608 7.0605 8.70334C7.13025 8.79046 7.24942 8.8432 7.3778 8.8432H8.94735L8.03897 11.7518C7.99507 11.8925 8.07957 12.039 8.24081 12.1022C8.29357 12.1229 8.34963 12.1328 8.40535 12.1328C8.51973 12.1328 8.63189 12.0905 8.70532 12.0128L12.9221 7.55444C13.0096 7.46211 13.0247 7.33736 12.9609 7.23291C12.8974 7.12861 12.766 7.06242 12.6222 7.06242ZM9.22184 10.4605L9.79889 8.61219C9.8273 8.52074 9.80222 8.42363 9.73063 8.3492C9.65907 8.27466 9.54912 8.23118 9.43254 8.23118H7.96223L9.34545 5.74483H11.1212L10.3819 7.25562C10.3357 7.34991 10.3501 7.45659 10.4206 7.5404C10.4911 7.62424 10.608 7.67445 10.7331 7.67445H11.8569L9.22184 10.4605Z"
      fill="currentColor"
    />
  </svg>
);

const NudgeConfigurationResource: ResourceItem = {
  name: resourceName.nudgeConfiguration,
  // identifier: ModuleIdentifierConst.NEED_TO_PAY,
  // show: `${resourceName.needToPay}/show/:id`,
  identifier: ModuleIdentifierConst.NUDGE_CONFIGURATION,
  list: `${resourceName.nudgeConfiguration}`,
  create: `${resourceName.nudgeConfiguration}/create`,
  edit: `${resourceName.nudgeConfiguration}/edit/:id`,
  show: `${resourceName.nudgeConfiguration}/show/:id`,
  options: { label: 'Nudge Configuration' },
  meta: {
    label: 'Nudge Configuration',
    icon: img,
  },
};

export default NudgeConfigurationResource;
